<template>
    <div class="approved-subjects__content d-flex flex-column flex-sm-row align-center justify-space-around py-3 pl-3 py-sm-5 pl-sm-5">
        <v-dialog v-model="modal" width="fit-content" scrollable >
            <SubjectModal :selected-subject="selectedSubject" :selected-subject-parts="selectedSubjectParts" @close="closeSubjectModal"/>
        </v-dialog>
        <v-progress-circular v-if="loading" indeterminate color="#ccc"></v-progress-circular>
        <div v-else-if="!subjects.length" class="text-center grey--text text--darken-2">
            <v-icon class="mr-3">mdi-inbox</v-icon>
            <span>{{ $t('modules.portalalumno.dashboard.subjectsTab.approved.noSubjects') }}</span>
        </div>
        <template v-else>
            <div class="approved-subjects__content-grid">
                <div style="padding-bottom: 10px; margin-right: 1.5em;" v-for="(subjectsByRecord, index) in subjects" :key="`${subjectsByRecord.studentRecordId}-${index}`">
                    <div class="d-flex align-center table-sizing">
                        <div style="font-weight: bold; font-size: 1em">{{ subjectsByRecord.careerDescription }}</div>
                    </div>
                    <div class="d-flex align-center table-sizing">
                        <div class="caption font-italic">{{ $t('modules.portalalumno.dashboard.subjectsTab.approved.subjects') }}</div>
                        <div class="caption font-italic text-center">{{ $t('modules.portalalumno.dashboard.subjectsTab.approved.score') }}</div>
                    </div>
                    <div class="approved-subjects__content-grid-row d-flex table-sizing py-2" v-for="(subject,idx) in subjectsByRecord.passedSubjects" :key="`approved-${idx}`">
                        <div class="body-2 primary--text ">{{ subject.description }}</div>
                        <div class="body-2 primary--text font-weight-bold d-flex align-center justify-center">{{ subject.grade }}</div>
                    </div>
                </div>
            </div>
        </template>
    </div>
</template>

<script>
    import { $subjects } from '../Services';
    import { mapGetters } from 'vuex';
    import SubjectModal from './SubjectModal';
    import authService from '../../../../core/plugins/auth.service';

    export default {
        name: 'ApprovedSubjects',
        components: { SubjectModal },
        data() {
            return {
                loading: false,
                modal: false,
                selectedSubject: null,
                approvedSubjectsFromAPI: [],
            }
        },
        computed: {
            ...mapGetters({
                studentRegister: 'commons/getStudentActualRegister',
                cacheSubjects: 'commons/getStudentApprovedSubjects',
                studentUserId: 'commons/getStudentUserID'
            }),
            score() {
              const isWithoutDeferralsNumeric = this.cacheSubjects?.notaAprobados && typeof this.cacheSubjects.notaAprobados == 'number';
              const isWithDeferralsNumeric = this.cacheSubjects?.notaAplazos && typeof this.cacheSubjects.notaAplazos == 'number';

              const withoutDeferrals = isWithoutDeferralsNumeric ? this.cacheSubjects.notaAprobados : null;
              const withDeferrals = isWithDeferralsNumeric ? this.cacheSubjects.notaAplazos.toFixed(1) : null;

              return { withoutDeferrals, withDeferrals };
            },
            subjects(){
                if (this.cacheSubjects) {
                    return this.cacheSubjects;
                } else return []
            },
            mod2019() {
                return !!this.subjects.find(subject => subject.mod2019)
            },
            selectedSubjectParts() {
                if (!this.selectedSubject) return []

                const { exams } = this.selectedSubject;

                return [
                    { title: 'Año / Período', content: this.selectedSubject.term || '-' },
                    { title: 'M1', content: exams[0]?.score.toFixed(1) || '-' },
                    { title: 'M2', content: exams[1]?.score.toFixed(1) || '-' },
                    { title: 'M3', content: exams[2]?.score.toFixed(1) || '-' },
                    { title: 'M4', content: exams[3]?.score.toFixed(1) || '-' },
                    { title: 'Examen', content: this.selectedSubject.examScore || '-' },
                    { title: 'Recuperatorio', content: this.selectedSubject.recovery || '-' },
                    { title: 'Nota Final', content: this.selectedSubject.score },
                ]
            }
        },
        mounted(){
            if (!this.cacheSubjects) this.getData();
        },
        methods: {
            async getData(){
                try{
                    this.loading = true
                    const studentUser = authService.isAdvisor() ? JSON.parse(localStorage.getItem('alumnoImpersonado')).id : this.studentUserId;
                    const response = await $subjects.find('passed', null, {params: { studentUserId: studentUser }})

                    await this.$store.dispatch('commons/setStudentApprovedSubjects', response.data);
                } catch(err) {
                    this.$store.dispatch('commons/setStudentApprovedSubjects', null);
                    throw err
                } finally {
                    this.loading = false;
                }
            },
            openSubjectModal(subject) {
                this.selectedSubject = subject;
                this.modal = true;
            },
            closeSubjectModal() {
                this.modal = false;
                this.selectedSubject = null;
            }
        },
    }
</script>

<style lang='sass' scoped>

  .table-sizing
    div:nth-child(1)
      flex: 1
    div:nth-child(2)
      width: 20%
    div:nth-child(3)
      width: 15%
    div:nth-child(4)
      width: 7.7%

  .approved-subjects
    &__content
        width: 100%
        max-height: 254px
        min-height: 250px
        &-grid
          height: 100%
          max-height: 100%
          width: 100%
          overflow-y: scroll
          &-row
            border-bottom: 1px solid #ddd
            .view-subject:hover
              color: var(--v-primary-base) !important

        .resume
          .average
            .circle-blue
              width: 50px
              height: 50px
              border-radius: 50%
              background: var(--v-primary-base)

              span
                width: 50px

  @media only screen and (max-width: 600px)
    .approved-subjects
      &__content
          max-height: 254px * 2
          &-grid
            width: 100%
            &-row
              width: 100%
          .resume
            min-height: auto
</style>
